import * as Clipboard from 'expo-clipboard'

export async function copyStringToClipboard(text: string): Promise<void> {
  await Clipboard.setStringAsync(text)
}
